import Http from './http'
import { EventObserver } from '../util/event-observer'

class AuthService extends EventObserver {
  constructor () {
    super()
    this.obrasUrl = 'auth-biblioteca'
  }

  changePassword (password) {
    const request = {
      password: password
    }
    return Http.post(this.obrasUrl + '/password', request, { responseType: 'text' })
  }

  changePasswordById (id,request) {
    return Http.post(this.obrasUrl + '/password/'+id, request, { responseType: 'text' })
  }

  passwordReset (request) {
    return Http.post(this.obrasUrl + '/reset', request, { responseType: 'text' })
  }

  passwordForgot (username) {
    const request = {
      username: username
    }
    return Http.post(this.obrasUrl + '/forgot', request, { responseType: 'text' })
  }

  register(data) {
    return Http.post(this.obrasUrl + '/register', data, { responseType: 'text' })
  }

  login (username, password) {
    const login = {
      username: username,
      password: password
    }

    return Http.post(this.obrasUrl + '/authBiblioteca', login)
  }
}

export default new AuthService()
